import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/root/injective/injective-helix/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/root/injective/injective-helix/app/layouts/default.vue").then(m => m.default || m)),
  institutional: defineAsyncComponent(() => import("/root/injective/injective-helix/app/layouts/institutional.vue").then(m => m.default || m))
}